import { useRouter } from "next/router";
import Heading from "src/components/Heading";
import Paragraph from "src/components/Paragraph";
import gutter from "src/functions/gutter";

function PricesFree() {
  const { locale: lang } = useRouter();

  switch (lang) {
    case `cs`:
      return (
        <>
          <Heading type="h2" variant="primary" title={`Obsah zdarma`} />
          <Paragraph size="md" width={`semibold`}>
            Vyzkoušejte ukázkové lekce zdarma!
          </Paragraph>
          <Paragraph
            size="xn"
            width={`regular`}
            style={gutter(`margin`, `bottom`, `0`)}
          >
            Chcete si vyzkoušet, jestli vám přístup vybrané lektorky nebo
            lektora sedí, než si koupíte nabízený kurz nebo lekci? Zobrazete si
            lektorský profil a najděte ukázkové lekce zdarma. Jsou označené
            značkou Ukázka. Díky tomu budete mít jistotu, že jste zvolili
            správně.
          </Paragraph>
          <br />
        </>
      );
    case `sk`:
      return (
        <>
          <Heading type="h2" variant="primary" title={`Obsah zadarmo`} />
          <Paragraph size="md" width={`semibold`}>
            Vyskúšajte ukážkové lekcie zadarmo!
          </Paragraph>
          <Paragraph
            size="xn"
            width={`regular`}
            style={gutter(`margin`, `bottom`, `0`)}
          >
            Chcete si vyskúšať, či vám prístup vybranej lektorky alebo lektora
            sedí, než si kúpite ponúkaný kurz alebo lekciu? Zobrazite si
            lektorský profil a nájdite ukážkové lekcie zadarmo. Sú označené
            značkou Ukážka. Vďaka tomu budete mať istotu, že ste zvolili
            správne.
          </Paragraph>
          <br />
        </>
      );
    default:
      // also EN
      return (
        <>
          <Heading type="h2" variant="primary" title={`Free content`} />
          <Paragraph size="md" width={`semibold`}>
            Try sample classes for free!
          </Paragraph>
          <Paragraph
            size="xn"
            width={`regular`}
            style={gutter(`margin`, `bottom`, `0`)}
          >
            Do you want to test whether the approach of the selected instructor
            suits you before you buy the offered serie or class? View the
            instructor's profile and find free sample class. They are marked
            with the Sample tag. This will ensure that you have made the right
            choice.
          </Paragraph>
          <br />
        </>
      );
  }
}

export default PricesFree;
